<template>
    <psi-dialog
        icon="mdi-clipboard-text"
        title="Background Check"
        @close="$emit('close')"
    >
        <h3>Hello {{ currentStudent.name }}, are you ready to get started?</h3>
        <template #actions>
            <v-btn color="accent" :href="applyUrl" large>
                <v-icon class="mr-2">mdi-clipboard-text</v-icon>Start Tenant Sample Report
                <v-icon class="ml-2">mdi-chevron-right</v-icon>
            </v-btn>
        </template>
    </psi-dialog>
</template>

<script>
import StudentApply from '../mixins/apply';

export default {
    name: "student-start",
    mixins: [StudentApply],
    props: {
        currentStudent: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
</style>